import { MS_APPLICATION_ID, MS_CLIENT_SECRET, MS_REDIRECT_URL } from "src/app/constant/constant.component";

export const OAuthSettings = {
  appId: MS_APPLICATION_ID,
  redirectUri: MS_REDIRECT_URL,
  client_secret: MS_CLIENT_SECRET,

  scopes: [
    "user.read",
    "mailboxsettings.read",
    "calendars.readwrite",
    "Bookings.Manage.All",
    "Bookings.ReadWrite.All",
    "BookingsAppointment.ReadWrite.All",
    "Calendars.ReadWrite.Shared",
    "Calendars.ReadWrite.Shared"

  ],
  response_mode: "fragment"
};
